import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-x-x3 gap-y-x4" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-full sm:col-span-1"
}
const _hoisted_3 = {
  key: 1,
  class: "col-span-full sm:col-span-1"
}
const _hoisted_4 = {
  key: 2,
  class: "col-span-full sm:col-span-1"
}

import CertificatesList from '@/shared/product/details/ui/product-specifications/CertificatesList.vue';
import TestsList from '@/shared/product/details/ui/product-specifications/TestsList.vue';
import ClimateEmissionsList from '@/shared/product/details/ui/product-specifications/ClimateEmissionsList.vue';
import useProductSpecificationsData
    from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTransparencyDetails',
  setup(__props) {

const { specifications } = useProductSpecificationsData();
const { climateEmissionsCollection } = useProductSpecificationsData();
const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_unref(specifications)?.certificates?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CertificatesList, {
            certificates: _unref(specifications).certificates,
            title: _unref(labels).certificatesTitle
          }, null, 8, ["certificates", "title"])
        ]))
      : _createCommentVNode("", true),
    (!!_unref(specifications)?.tests?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(TestsList, {
            tests: _unref(specifications).tests,
            title: _unref(labels).testsTitle
          }, null, 8, ["tests", "title"])
        ]))
      : _createCommentVNode("", true),
    (_unref(climateEmissionsCollection))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(ClimateEmissionsList)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})